/* ============================================================
   Rhiza Reads — theme.js
   ------------------------------------------------------------
   Vanilla JS only. Each feature is a self-contained init that
   no-ops if its markup isn't on the page, so this single file
   is safe to load on every template. No frameworks, no deps.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Sticky header: shadow on scroll + mobile menu toggle ---- */
  function initHeader() {
    var nav = document.getElementById('site-nav');
    if (!nav) return;

    var toggle = nav.querySelector('.nav-toggle');
    var mobileMenu = document.getElementById('mobile-menu');

    var onScroll = function () {
      nav.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (!toggle || !mobileMenu) return;

    var setMenuOpen = function (open) {
      toggle.setAttribute('aria-expanded', String(open));
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', String(!open));
    };

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      setMenuOpen(!expanded);
    });

    // Close the menu after tapping an in-page anchor, then scroll.
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (href && href.charAt(0) === '#' && href.length > 1) {
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            setMenuOpen(false);
            window.setTimeout(function () {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              history.replaceState(null, '', href);
            }, 340);
            return;
          }
        }
        setMenuOpen(false);
      });
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth >= 990) setMenuOpen(false);
    });
  }

  /* ---- FAQ accordion: animate native <details> open/close ---- */
  function initFaq() {
    var items = document.querySelectorAll('.faq-item');
    if (!items.length) return;

    items.forEach(function (item) {
      var summary = item.querySelector('.faq-question');
      var answer = item.querySelector('.faq-answer');
      var inner = item.querySelector('.faq-answer-inner');
      if (!summary || !answer || !inner) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item._animating) return;

        if (item.open) {
          item._animating = true;
          answer.style.height = inner.offsetHeight + 'px';
          item.classList.remove('is-open');
          void answer.offsetHeight; // reflow
          answer.style.height = '0px';
          var onCloseEnd = function () {
            item.open = false;
            answer.style.height = '';
            item._animating = false;
            answer.removeEventListener('transitionend', onCloseEnd);
          };
          answer.addEventListener('transitionend', onCloseEnd);
        } else {
          item._animating = true;
          item.open = true;
          var target = inner.offsetHeight;
          answer.style.height = '0px';
          item.classList.add('is-open');
          void answer.offsetHeight; // reflow
          answer.style.height = target + 'px';
          var onOpenEnd = function () {
            answer.style.height = '';
            item._animating = false;
            answer.removeEventListener('transitionend', onOpenEnd);
          };
          answer.addEventListener('transitionend', onOpenEnd);
        }
      });
    });
  }

  /* ---- Newsletter → Kit (ConvertKit): async submit with states ----
     The form posts to the Kit form action URL set in theme settings.
     We submit via fetch so we can show inline success/error without a
     full-page redirect. If JS fails, the form still posts natively. */
  function initNewsletter() {
    var forms = document.querySelectorAll('.js-kit-form');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var status = form.parentElement.querySelector('.js-kit-status');
      var button = form.querySelector('button[type="submit"]');
      var buttonLabel = button ? button.textContent : '';

      form.addEventListener('submit', function (e) {
        // No action configured → let it fall back / do nothing harmful.
        if (!form.getAttribute('action') || form.getAttribute('action').indexOf('REPLACE') !== -1) {
          return;
        }
        e.preventDefault();

        if (button) { button.disabled = true; button.textContent = 'Sending…'; }
        if (status) { status.hidden = true; status.className = 'form-status js-kit-status'; }

        fetch(form.getAttribute('action'), {
          method: 'POST',
          body: new FormData(form),
          headers: { accept: 'application/json' }
        })
          .then(function (res) { return res.ok ? res.json().catch(function () { return {}; }) : Promise.reject(res); })
          .then(function () {
            form.reset();
            if (status) {
              status.textContent = 'Thank you. Please check your inbox to confirm.';
              status.classList.add('form-status--success');
              status.hidden = false;
            }
            form.hidden = true;
          })
          .catch(function () {
            if (status) {
              status.textContent = 'Something went wrong. Please try again, or email rhiza@rhizareads.com.';
              status.classList.add('form-status--error');
              status.hidden = false;
            }
          })
          .finally(function () {
            if (button) { button.disabled = false; button.textContent = buttonLabel; }
          });
      });
    });
  }

  /* ---- Product: quantity stepper (progressive enhancement) ---- */
  function initQuantity() {
    document.querySelectorAll('.quantity').forEach(function (wrap) {
      var input = wrap.querySelector('input[type="number"]');
      if (!input) return;
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var next = (parseInt(input.value, 10) || min) + step;
          input.value = next < min ? min : next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---- Boot ---- */
  function init() {
    initHeader();
    initFaq();
    initNewsletter();
    initQuantity();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
